export default __webpack_public_path__ + "static/media/Weissenhof Grotesk W01 Regular.1fb4a878.ttf";